module.exports = __webpack_public_path__ + "static/img/2_1_4_1.896cd51d.jpg";